import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorage } from 'angular-web-storage';

import {
  LightspeedRegister,
} from '../../../../../../../models/lightspeed-register';
import {
  StaffSiteSaleService,
} from '../../../../../../../services/staff-site-sale/staff-site-sale.service';


@Component({
  selector: 'app-select-register-modal',
  templateUrl: './select-register-modal.component.html',
  styleUrls: ['./select-register-modal.component.css']
})
export class SelectRegisterModalComponent implements OnInit {

  @Input() saleId: number;
  @Input() submitCallback: (register: LightspeedRegister | null) => void;

  public loadingRegisters = false;
  public registers: LightspeedRegister[] = [];
  public selectedRegisterId: string | null = null;
  public locationLinked = false;
  public locationId: number | null = null;
  public locationName: string | null = null;

  public serverError: number = null;

  // Persisted across sessions: maps Capitan location_id (stringified) to the
  // last register_id chosen for that location. Used to preselect the dropdown
  // the next time this modal is opened for a sale at the same location.
  @LocalStorage() public lastLightspeedRegisterIdByLocation: { [locationId: string]: string };

  constructor(
    public activeModal: NgbActiveModal,
    private staffSiteSaleService: StaffSiteSaleService,
  ) {}

  ngOnInit() {
    this.loadingRegisters = true;
    this.staffSiteSaleService
      .getLightspeedRegistersForSale(this.saleId)
      .then(response => {
        this.registers = response.registers;
        this.locationLinked = response.location_linked;
        this.locationId = response.location_id;
        this.locationName = response.location_name;

        if (this.registers.length > 0) {
          const remembered = this.getRememberedRegisterId();
          if (remembered !== null && this.registers.some(r => r.id === remembered)) {
            this.selectedRegisterId = remembered;
          } else {
            this.selectedRegisterId = this.registers[0].id;
          }
        }
      })
      .catch(reason => { this.serverError = reason.status; })
      .finally(() => { this.loadingRegisters = false; });
  }

  public handleSave() {
    const register = this.registers.find(r => r.id === this.selectedRegisterId) || null;
    if (register !== null && this.locationId !== null) {
      const updated = { ...(this.lastLightspeedRegisterIdByLocation || {}) };
      updated[this.locationId.toString()] = register.id;
      this.lastLightspeedRegisterIdByLocation = updated;
    }
    this.submitCallback(register);
    this.activeModal.close();
  }

  public handleSendWithoutRegister() {
    this.submitCallback(null);
    this.activeModal.close();
  }

  private getRememberedRegisterId(): string | null {
    if (this.locationId === null) {
      return null;
    }
    const map = this.lastLightspeedRegisterIdByLocation;
    if (!map) {
      return null;
    }
    const value = map[this.locationId.toString()];
    return value || null;
  }
}
